
import carousel_onload from "./carousel/onLoad"
import pictures_and_map_browser from "./pictures_and_map_browser/onLoad"
import contact from "./contact/onLoad"
import Searches from "./searches/onLoad"

const onLoad = () => {
  carousel_onload()
  pictures_and_map_browser.onLoad()
  contact.onLoad()
  Searches.onLoad()
}

export default onLoad
